<template>
	<div>
		<buttonlist @help="help" @reflash="reflash" ref="SetBtn"></buttonlist>
		<el-table
			id="xpane-0"
			:data="dataSet"
			v-loading="loading"
			:highlight-current-row="true"
			show-overflow-tooltip="true"
			border
			stripe
			size="mini"
			:height="tableHeight"
			header-row-class-name="headerclass"
			style="width: 100%; margin-top:0px"
			ref="singleTable"
		>
			<el-table-column type="selection" v-if="false"></el-table-column>
			<el-table-column show-overflow-tooltip prop="tablename" :label="$t('getapi[6051]')" width="200"></el-table-column>
			<el-table-column show-overflow-tooltip prop="ordinal" :label="$t('getapi[871]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="prefix" :label="$t('getapi[6052]')" width="100"></el-table-column>
			<el-table-column show-overflow-tooltip prop="remark" :label="$t('getapi[6053]')" width="200"></el-table-column>
			<el-table-column :label="$t('getapi[6048]')" width="60">
				<template slot-scope="scope">
					<el-button :disabled="!btn.edit" @click.native.prevent="edit(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}</el-button>
				</template>
			</el-table-column>
		</el-table>

		<el-dialog v-dialogDrag :title="$t('getapi[4656]')" :visible.sync="isVisible" width="30%">
	<!--		<el-row>
				<el-col :span="24">
					<el-form :inline="true" :model="dataDetail" class="demo-form-inline" label-width="120px" label-position="left" size="small">
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[6051]')"><el-input v-model="dataDetail.tablename" disabled="false"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[871]')"><el-input v-model="dataDetail.ordinal" disabled="false"></el-input></el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[6052]')"><el-input v-model="dataDetail.prefix"></el-input></el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item :label="$t('getapi[6053]')"><el-input v-model="dataDetail.remark"></el-input></el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-col>
			</el-row>-->
			<el-divider></el-divider>
			<div :style="{border:'1px solid #DCDFE6'}">
				<table>
					<tr>
						<td>{{$t('getapi[6051]')}}</td>
						<td><el-input v-model="dataDetail.tablename" disabled="false"></el-input></td>
						<td>{{$t('getapi[871]')}}</td>
						<td>
							<el-input v-model="dataDetail.ordinal" disabled="false"></el-input>
						</td>
					</tr>
					<tr>
						<td>{{$t('getapi[6052]')}}</td>
						<td><el-input v-model="dataDetail.prefix"></el-input></td>
						<td>{{$t('getapi[6053]')}}</td>
						<td><el-input v-model="dataDetail.remark"></el-input></td>
					</tr>
				</table>
			</div>
			<el-divider></el-divider>
			<span slot="footer" class="dialog-footer">
				<el-button size="small" @click="isVisible = false">{{ $t('getapi[2054]') }}</el-button>
				<el-button size="small" type="primary" @click="save">{{ $t('getapi[937]') }}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
export default {
	name:'ordinal',
    computed: {
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
			dataSet: [], // 主表数据
			isVisible: false, // 查询列表是否显示
			userData: [], // 用户信息
			DbTbNames: '',
			pageIndex: 1, // 当前页
			pageSize: 50, // 当前页数据量
			SelectIndexs: 1, //当前页面
			total: 0, // 数据总量
			loading: false, // 主表加载状态
			dataDetail: {},
			btn: {
				del: false,
				edit: false
			},
            scrollTop:0,
		};
	},
    watch: {
        dataSet: function () {
            let that = this
            that.$nextTick(function () {
                that.$processdata.initForm(0)
            })
        },
    },
	mounted: function() {
		let that = this;
		that.userData = JSON.parse(sessionStorage.getItem('userData'));
		that.user = that.userData.username;
		that.getView();
		that.authority();
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })
    },
	methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[4468]"),this.$t("getapi[12]"));
        },
		//按钮操作权限
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
			that.btn.edit = true;
			that.btn.del = true;
			that.$refs.SetBtn.SetButtonEnable('refresh');
		},
		// 数据一览
		getView() {
			let that = this;
			that.loading = true;
			let data = {};
			that.$http.urlpost('/Sys/Currency/GetOrdinalTableList', data, function(res) {
				if (res.Success == 1) {
					that.dataSet = res.DataContent.Table;
					that.loading = false;
					that.authority();
				}
			});
		},
		// 刷新
		reflash() {
			let that = this;
			that.getView();
		},
		edit(row) {
			let that = this;
			that.isVisible = true;
			let parm = {
				Code: row.tablename
			};
			that.$http.urlpost('/Sys/Currency/GetOrdinalTableInfo', parm, function(res) {
				if (res.Success == 1) {
					that.dataDetail = res.DataContent;
				}
			});
		},
		save() {
			let that = this;
			let arr = [];
			arr = [...arr, that.dataDetail];
			let lan = that.$processdata.getLang()
            for (let i = 0; i < arr.length; i++) {
                arr[i].LangType = lan
            }
			let parm = arr;
			that.$http.urlpost('/Sys/Currency/SaveOrdinalTable', parm, function(res) {
				if (res.Success == 1) {
					that.$message.success(Common.SuccessMsg);
					that.isVisible = false;
					that.getView();
				}
			});
		}
	}
};
</script>

<style scoped lang="less">
table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
		white-space: pre;
	}
}
.el-form--inline .el-form-item {
	display: flex;
}

.tb-edit .el-input {
	display: none;
}

.tb-edit .current-row .el-input {
	display: block;
}

.tb-edit .current-row .el-input + span {
	display: none;
}

.el-table .hidden-row {
	display: none;
}
</style>
